import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServicesService } from './auth-services.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private auth: AuthServicesService, private router: Router) { }
  
  canActivate(){
    if(!this.auth.isAuthenticated()){
      this.router.navigateByUrl('se_connecter');
      return false;
    }
    return true;
  }
}
